export class UpdateUserRolesDto {
  username: string;
  rolesToAdd: string[] = [];
  rolesToRemove: string[] = [];
  performedByUsername: string;
  applicationId: string;

   constructor( username: string = '', 
                rolesToAdd: string[] = [], 
                rolesToRemove: string[] = [], 
                performedByUsername: string = '', 
                applicationId: string = '') {
    this.username = username;
    this.rolesToAdd = rolesToAdd;
    this.rolesToRemove = rolesToRemove;
    this.performedByUsername = performedByUsername;
    this.applicationId = applicationId;
  }
}